export default __webpack_public_path__ + "7d24f07.png";